import { useLocation, useNavigate } from "react-router-dom";
import { HugeiconsIcon } from '@hugeicons/react';
import { HelpCircleIcon as HelpCircle, Home01Icon as Home } from '@hugeicons/core-free-icons';
import { useEffect } from "react";
import { KoboyoIcon } from "@/components/illustrations/KoboyoIcons";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-background to-secondary/5 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl" />
      
      <div className="relative z-10 w-full px-4 py-12">
        <div className="mx-auto max-w-2xl text-center space-y-8">
          <div className="flex justify-center">
            <KoboyoIcon name="shrug" className="h-40 w-auto text-muted-foreground/30" />
          </div>

          <div className="space-y-3">
            <h1 className="text-5xl md:text-6xl font-bold text-foreground">
              Page not found
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-xl mx-auto">
              This page doesn't exist or may have been moved. Let's get you back on track.
            </p>
          </div>

          <div className="bg-card/50 border border-border/50 rounded-lg p-6 backdrop-blur-sm">
            <div className="flex items-start gap-3 text-sm text-muted-foreground">
              <HugeiconsIcon icon={HelpCircle} className="w-5 h-5 flex-shrink-0 text-foreground/40 mt-0.5"  />
              <p>
                If you believe this is an error, try refreshing the page or go back to the dashboard.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <button 
              onClick={() => navigate("/")}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-primary/90 transition-all duration-300 group"
            >
              <HugeiconsIcon icon={Home} className="w-5 h-5"  />
              Go to Dashboard
            </button>
          </div>

          <p className="text-xs text-muted-foreground/60 pt-4">
            404 | {location.pathname}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
